import { Link as GatsbyLink } from "gatsby"
import { styled } from "@mui/system"

const Link = styled(GatsbyLink)(({ theme }) => ({
  color: theme.palette.secondary.main,
  textDecoration: "none",
}))

export default Link
